export const RESET_FORM_DATA = 'RESET_FORM_DATA';

export const resetFormData = () => ({
    type: RESET_FORM_DATA,
});
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';

export const updateFormData = (data) => ({
    type: UPDATE_FORM_DATA,
    data,
});

// Replaces compensate entirely with `data` (UPDATE_FORM_DATA merges instead)

export const setCurrentStep = (step) => ({
    type: SET_CURRENT_STEP,
    data: step,
});